import { useProducts } from '../../api/hooks/products/useProducts';
import { UpgradeRequiredBanner } from '../../components/atoms/UpgradeRequiredBanner';
import { EntityPaginationData } from '../../components/molecules/EntityPaginationData';
import { SORT_BY_PRODUCTS, SUBSCRIPTION } from '../../interfaces/enumerables';
import { getProductsSortByFilter } from '../../services/utils/sortData';
import { useHasActivePlan } from '../../services/utils/useHasActivePlan';
import { ProductItemCard } from './components/ProductItemCard';

export const ProductsScreen = () => {
  const productsSortByFilter = getProductsSortByFilter();
  const hasActivePlan = useHasActivePlan(false, SUBSCRIPTION.SIMPLE_V1);

  return (
    <EntityPaginationData
      useDataHook={useProducts}
      ItemCardData={ProductItemCard}
      sortByFilter={productsSortByFilter}
      hideCreateButton={!hasActivePlan}
      sortByDefaultKey={SORT_BY_PRODUCTS.NAME}
      headerSlot={!hasActivePlan ? <UpgradeRequiredBanner /> : undefined}
    />
  );
};
